import { z } from 'zod'

import { hasDigitOrSpecialCharacter, hasLower, hasUpper } from '@portal/lib/password-requirement'

import { env, isFeatureEnabled } from '@/shared/config'

export const passwordInputSchema = z
    .string()
    .trim()
    .min(env.ACCOUNT_PASSWORD_MIN_LEN, { message: 'password_too_short' })
    .max(env.ACCOUNT_PASSWORD_MAX_LEN, { message: 'password_very_long' })
    .refine(
        (password) => {
            if (isFeatureEnabled('strong-password-validation')) {
                return hasUpper.test(password) && hasLower.test(password)
            }
            return true
        },
        {
            message: 'must_contain_both_uppercase_and_lowercase_letters',
        }
    )
    .refine(
        (password) => {
            if (isFeatureEnabled('strong-password-validation')) {
                return hasDigitOrSpecialCharacter.test(password)
            }
            return true
        },
        {
            message: 'must_contain_digit_or_special_character',
        }
    )
